import { render } from "./FlowBranchMenu.vue?vue&type=template&id=c4005ad0&scoped=true"
import script from "./FlowBranchMenu.vue?vue&type=script&lang=ts"
export * from "./FlowBranchMenu.vue?vue&type=script&lang=ts"

import "./FlowBranchMenu.vue?vue&type=style&index=0&id=c4005ad0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c4005ad0"

export default script